// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"12":"e9ed012b","551":"034eee0c","821":"c455f3e4","842":"12dfbeb4"}[chunkId] + ".chunk.js";
};